<template>
	<div class="v-application">
		<headerNav @handleBrage="handleBrage"></headerNav>
		<div class="v-application-wrapper">
			<div class="v-application-container">
				<sideBar ref="sideBarRef"></sideBar>
				<div class="v-content-white-wrapper">
					<div class="table-container">
						<div class="card-header">
							<h1 class="fs-20">User Profile</h1>
						</div>
						<div class="form-container">
							<el-form ref="ruleForm" label-position="left" :model="ruleForm" :rules="rules" label-width="100%">
								<el-form-item label="Nickname:">
								    <el-input v-model="ruleForm.fullName"></el-input>
								</el-form-item>
								<el-form-item label="Avatar:" prop="sfzfront">
									<div class="v-upload-container">
										<div class="v-upload-area" style="position: relative;">
											<input style="width:100%;height:100%;opacity:0;position: absolute;top:0;left:0;z-index: 2;cursor: pointer;" type="file" accept="image/*" @change="onFileChange" />
											<div v-if="!ruleForm.storeHead" class="upload-placeholder">
												<span>+</span>
											</div>
											<template v-else>
												<img :src="ruleForm.storeHead" alt="Uploaded photo" class="uploaded-img" />
											</template>
											
										</div>
									</div>
								</el-form-item>
								
								<el-form-item>
								    <el-button type="primary" @click="submitForm()">Save</el-button>
								    <el-button @click="resetForm()">Reset</el-button>
								</el-form-item>
								
							</el-form>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import headerNav from '../../components/headerNativation.vue'
	import sideBar from '../../components/sideBar.vue'
	import tabBar from '../../components/tabBar.vue'
	import {uploadFile} from '../../api/home'
	import {updateStoreMsg,queryStoreMsg} from '../../api/api'

	export default {
		components: {
			headerNav,
			sideBar,
			tabBar
		},
		data() {
			return {
				selectedFile: null,
				ruleForm: {
					fullName: '',
					storeHead: '',
				},
				rules: {
				    fullName: [
				        { required: true, message: 'Please enter a nickname', trigger: 'change' }
				    ],
				    storeHead: [
				        { required: true, message: 'Please upload your profile picture', trigger: 'change' }
				    ],
				},
			}
		},
		created() {
			this.init()
		},
		methods: {
			handleBrage(){
				this.$refs.sideBarRef.handleBrage()
			},
			init(){
				var that = this
				var params = {}
				queryStoreMsg(params).then(res => {
					if (res.code == 200) {
						that.ruleForm.storeHead = res.data.storeHead
						that.ruleForm.fullName = res.data.fullName
					}
				});
			},
			onFileChange(e) {
				this.selectedFile = e.target.files[0];
				this.uploadPhoto()
			},
			uploadPhoto() {
				// 上传到服务器
				const formData = new FormData();
				formData.append('file', this.selectedFile, this.selectedFile.name);
				let file = formData
				const loading = this.$loading({
				    lock: true,
				    text: 'Loading',
				    spinner: 'el-icon-loading',
				    background: 'rgba(0, 0, 0, 0.2)'
				});
				uploadFile(file).then(res => {
					loading.close();
					if (res.code == 200) {
						// 假设接口返回的文件URL在 res.data.url 中
						this.ruleForm.storeHead = res.url;
						this.$message.success('Image uploaded successfully');
					} else {
						this.$message.error(res.msg || 'Image upload failed');
					}
				}).catch(err => {
					this.$message.error(err.msg || 'Image upload failed');
				});
			},
			submitForm() {
			    this.$refs.ruleForm.validate((valid) => {
			        if (valid) {
						var that = this
						var params = {
							fullName:this.ruleForm.fullName,
							storeHead:this.ruleForm.storeHead
						}
						updateStoreMsg(params).then(res => {
							if (res.code == 200) {
								this.$message.success('Submission successful!');
								setTimeout(() => {
									that.openPage('/')
								}, 1000)
							}else{
								this.$message.error('Submission failed!');
							}
						});
			        } else {
			            return false;
			        }
			    });
			},
			resetForm() {
			    this.$refs.ruleForm.resetFields();
			},
		}
	}
</script>

<style scoped>
	.form-container {
		width: 500px;
		padding: 0 10px;
	}
	.v-upload-container {
		position: relative;
		width: 100px;
		height: 100px;
		border: 2px dashed #eee;
		border-radius: 4px;
		cursor: pointer;
		overflow: hidden;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.upload-placeholder {
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 24px;
		color: #999;
		cursor: pointer;
	}

	.v-upload-container .v-upload-area {
		width: 100%;
		height: 100%;
	}

	.uploaded-img {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}
	/deep/ .el-form-item__content {
		margin-left: 0 !important;
	}
	@media (max-width: 768px) {
		.form-container {
			width: 100%;
			padding: 15px 10px;
		}
	}
	.v-upload-item {
	    color: #606266;
	    display: block;
	    overflow: hidden;
	    padding-left: 4px;
	    text-overflow: ellipsis;
	    transition: color .3s;
	    white-space: nowrap;
	}
	.v-upload-item [class^=el-icon] {
	    height: 100%;
	    margin-right: 7px;
	    color: #909399;
	    line-height: inherit;
	}
</style>
